import apiHeader from '@/helpers/apiHeader';

const draftListService = {
    list(params) {
        return apiHeader.get('request-pool/draft-list', { params });
    },
    create(params) {
        return apiHeader.post('request-pool/draft-list', params);
    },
    delete(id) {
        return apiHeader.delete(`request-pool/draft-list/${id}`);
    },
    detail(id) {
        return apiHeader.get(`request-pool/draft-list/${id}`);
    },
    patch(id, params) {
        return apiHeader.patch(`request-pool/draft-list/${id}`, params);
    },
};

export default draftListService;